import { render, staticRenderFns } from "./wtsList.vue?vue&type=template&id=9b27ec56&scoped=true"
import script from "./wtsList.vue?vue&type=script&lang=js"
export * from "./wtsList.vue?vue&type=script&lang=js"
import style0 from "./wtsList.vue?vue&type=style&index=0&id=9b27ec56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27ec56",
  null
  
)

export default component.exports